// src/main.jsx

import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App.jsx'; // App.jsx をインポート
import './styles/index.scss'; // グローバルCSSをインポート

ReactDOM.createRoot(document.getElementById('root')).render(
  <App />
);